module.exports = __webpack_public_path__ + "media/images/icons/mascot/2-e76330f91a925431a2337eccaf8e2fd1.png";